// Content-Disposition
const CONTENT_DISPOSITION = 'Content-Disposition'

/**
 * レスポンス処理ユーティリティークラス
 */
class ResponseUtil {
  /**
   * レスポンスヘッダーからファイル名を取得する
   * @param {Response} response レスポンス
   * @param {string} [header='Content-Disposition'] 取得先ヘッダー名
   * @returns {Stirng} ファイル名
   */
  getFilenameFromHeader(response, header = CONTENT_DISPOSITION) {
    if (header === CONTENT_DISPOSITION) {
      return this._getFilenameFromContentDisposition(response)
    }

    const target = response.headers.get(header)
    return (target && decodeURIComponent(target)) || null
  }

  /**
   * Content-Dispositionからファイル名を取得する
   * @param {Response} response レスポンス
   * @returns {Stirng} ファイル名
   */
  _getFilenameFromContentDisposition(response) {
    const contentDisposition = response.headers.get(CONTENT_DISPOSITION)
    if (!contentDisposition) return null

    const parts = contentDisposition.split(';').map((v) => v.trim())

    // "filename*"がある場合はそちらが優先
    // https://developer.mozilla.org/ja/docs/Web/HTTP/Headers/Content-Disposition#directives
    const filenameAsta = parts.find((p) => p.startsWith('filename*='))
    const filename = parts.find((p) => p.startsWith('filename='))

    if (filenameAsta) {
      const name = filenameAsta.split('=')[1].split(/'.*'/)[1]
      return decodeURIComponent(name)
    } else if (filename) {
      const name = filename.split('=')[1].replace(/^"|"$/g, '')
      return decodeURIComponent(name)
    }

    return null
  }
}

export default new ResponseUtil()
